import Heading from "src/Pages/Company/Dashboard/components/Heading";
import DashboardModuleSettings from "src/Pages/Company/Dashboard/pages/ModulesVisibilityConfiguration/DashboardModuleSettings";
import { Stack } from "@mui/material";

const ModulesVisibilityConfiguration = () => (
  <>
    <Stack gap="1.5rem">
      <Heading />
      <DashboardModuleSettings />
    </Stack>
  </>
);

export default ModulesVisibilityConfiguration;
